export default __webpack_public_path__ + "static/about-us-alex-749ea509bdeec6db3c9fcaf4711dfa00.webp";